import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './styles/globals.css'
import App from './App.tsx'
import GoogleAnalytics from './components/common/GoogleAnalytics.tsx'
import FacebookPixel from './components/common/FacebookPixel.tsx'
import MaintenancePage from './components/common/MaintenancePage.tsx'

const isMaintenanceMode = import.meta.env.VITE_APP_MAINTENANCE_PAGE === "true";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    {isMaintenanceMode ? (
      <MaintenancePage />
    ) : (
      <>
        {import.meta.env.VITE_APP_ENVIRONMENT !== "development" && (
          <FacebookPixel />
        )}
        {import.meta.env.VITE_APP_ENVIRONMENT !== "development" && (
          <GoogleAnalytics />
        )}
        <App />
      </>
    )}
  </StrictMode>,
)